import PropTypes from 'prop-types'
import { formatStringWithNewlines } from '@!/Util'
import { Dialog, Button } from '@chakra-ui/react'

export const ConfirmPopupModal = ({ text, handlePopup, isOpen = true }) => {
  return (
    <Dialog.Root placement="center" open={isOpen} onOpenChange={(details) => !details.open && handlePopup()}>
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content>
          <Dialog.Body>{formatStringWithNewlines(text)}</Dialog.Body>
          <Dialog.Footer>
            <Button onClick={handlePopup}>OK</Button>
          </Dialog.Footer>
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  )
}

ConfirmPopupModal.propTypes = {
  isOpen: PropTypes.bool,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  handlePopup: PropTypes.func.isRequired,
}
